/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Tabs_NotificationsInputs */

const he_account_tabs_notifications = /** @type {(inputs: Account_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התראות`)
};

const en_account_tabs_notifications = /** @type {(inputs: Account_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {Account_Tabs_NotificationsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_tabs_notifications = /** @type {((inputs?: Account_Tabs_NotificationsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Tabs_NotificationsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_tabs_notifications(inputs)
	return en_account_tabs_notifications(inputs)
});